import React from 'react';
import { XIcon } from 'lucide-react';
import { Band, PullQuote } from './Band';
import { compliancePoints, neverCaptured } from '../../data/site';
export function Compliance() {
  return <Band id="compliance" eyebrow="Compliance" title="Designed for the audit before it happens." description="Automated scoring of instrumented behaviour, used in an employment decision, is the most regulated category of software going. The architecture assumes that from the start." aside={<PullQuote data-id="element-30" data-mp="1y9jpx2ojsa02">
          We never claim compliance with a regulation. We produce the
          documentation the regulation asks for.
        </PullQuote>} data-id="element-29" data-mp="10m1ko1u3hq0t">
      <ul className="grid gap-px overflow-hidden rounded-2xl border border-mist bg-mist md:grid-cols-2 lg:grid-cols-3" data-id="element-31" data-mp="1jbrcqh6h3xp1">
        {compliancePoints.map(point => <li key={point.tag} className="bg-bone p-7" data-id="element-32" data-mp="7xdqthva5sbn">
            <span className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-33" data-mp="7vsx1ugsideu">
              {point.tag}
            </span>
            <p className="mt-3 max-w-[42ch] text-[15px] leading-relaxed text-graphite" data-id="element-34" data-mp="15mhbvr2xss1z">
              {point.body}
            </p>
          </li>)}
        <li className="bg-white/70 p-7" data-id="element-35" data-mp="10opjkvydr3x9">
          <span className="font-mono text-xs uppercase tracking-[0.14em] text-clay" data-id="element-36" data-mp="10pqu8zbhhoeg">
            Language discipline
          </span>
          <p className="mt-3 max-w-[42ch] text-[15px] leading-relaxed text-ink" data-id="element-37" data-mp="19nkmnz64nxwc">
            Every artificial constraint maps to something a real practitioner
            faces. The documented framing is discriminating power on
            job-relevant dimensions, and it holds up under a bias audit.
          </p>
        </li>
      </ul>

      <div className="mt-6 rounded-2xl border border-mist bg-white/60 p-8" data-id="element-38" data-mp="1xd5buzsvjre2">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-39" data-mp="1td4m4j0brtrp">
          Never captured
        </h3>
        <ul className="mt-6 flex flex-wrap gap-3" data-id="element-40" data-mp="27ccplo3ito1p">
          {neverCaptured.map(item => <li key={item} className="inline-flex items-center gap-2 rounded-full border border-mist bg-bone px-4 py-2 text-[15px] text-ink" data-id="element-41" data-mp="22dt23j9a4478">
              <XIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-42" data-mp="zxin8vig6n0j" />
              {item}
            </li>)}
        </ul>
      </div>
    </Band>;
}